// extracted by mini-css-extract-plugin
module.exports = {"changePlanSuccess":"ChangePlan_changePlanSuccess__k2NSe","successHeader":"ChangePlan_successHeader__3yKs0"};